<p-toast></p-toast>
<app-global-loading></app-global-loading>

<div class="block md:hidden bg-yellow-100 text-yellow-900 p-3 text-center">
  <i class="pi pi-exclamation-triangle mr-2"></i>
  This application is not optimized for mobile. Please use a desktop screen.
</div>

<div class="min-h-screen flex surface-ground">
  <app-global-sidebar *ngIf="showSidebar"></app-global-sidebar>
  <div class="min-h-screen flex flex-column overflow-y-scroll max-h-screen relative flex-auto"
    [ngClass]="{'lg:ml-[280px]': showSidebar, 'sidebar-showing': showSidebar}">
    <div class="flex flex-column flex-auto">
      <router-outlet></router-outlet>
      <!--div
        class="border-2 border-dashed surface-border border-round surface-section flex-auto"
      ></div-->
    </div>
  </div>
</div>